exports.onServiceWorkerUpdateReady = () => window.location.reload(true);
